<script setup lang="ts">
import AppHeader from './AppHeader.vue';
</script>

<template>
  <div class="layout-app">
    <div class="layout-app__header"><AppHeader /></div>
    <div class="layout-app__main">
      <main class="app-main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<style lang="scss">
.layout-app {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  > * {
    width: 100%;
  }

  &__main {
    width: 100%;
    flex: 1;
    min-height: 0;
  }
}

.app-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  padding: 0 1.5rem 1rem;

  @include ultrawide {
    padding: 0 0 1rem;
  }
}
</style>
